import { useQueryClient } from '@tanstack/react-query';
import { serviceCatalogServices } from '../services/service-catalog.service';

export const usePrefetchServiceCatalog = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['service-catalog', { ...filters, page: String(nextPage) }],
        queryFn: () => serviceCatalogServices.getServiceCatalog({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['service-catalog', { ...filters, page: String(prevPage) }],
        queryFn: () => serviceCatalogServices.getServiceCatalog({ ...filters, page: String(prevPage) }),
      });
    }
  };

  return { prefetchNextPage, prefetchPrevPage };
};
